// extracted by mini-css-extract-plugin
export default {"iconContainer":"TM_iconContainer__wgg4L","overlay":"TM_overlay__j4pnt","textContainer":"TM_textContainer__dggCY","iconSvg":"TM_iconSvg__ZmvsX"};